import { Component, OnInit } from '@angular/core';
import { EcomProd } from 'src/app/shared/classes/product';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-order-details',

  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.scss'
})
export class OrderDetailsComponent implements OnInit {

  public Osid: number = 0
  public hide: boolean = false

  constructor(private route: ActivatedRoute,) {

    this.route.queryParams.subscribe(params => {
      // console.log(params)
      const osid = params['Odid']
      this.Osid = parseInt(osid, 10) || 0
      // console.log(this.Osid)

      if (this.Osid == 1) {
        this.hide = false
      } else {
        this.hide = true
      }
    })

  
  }
  public ecomproduct: EcomProd = {};
  ngOnInit(): void {


  }
}
